const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignAppMinimal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 360 190",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1160.68,-779.196)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,643.521,-372.602)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.562,
    y: 559.609,
    width: 86.397,
    height: 45.384,
    style: {
      fill: "rgb(35,31,32)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,-1.13687e-13,792)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.793,
    y: 562.864,
    width: 39.073,
    height: 38.153,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,712.768,-405.592)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.63,
    y: 596.416,
    width: 11.508,
    height: 4.76,
    style: {
      fill: "rgb(36,151,194)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,-1.13687e-13,792)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.301,
    y: 596.416,
    width: 11.508,
    height: 4.76,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,698.731,-379.885)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.997,
    y: 578.219,
    width: 22.737,
    height: 15.447,
    style: {
      fill: "rgb(38,39,38)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,339.495,201.43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.764L22.665,13.764L22.665,0L10.438,0L10.507,2.815L0,2.824L0,13.764Z",
    style: {
      fill: "rgb(128,130,133)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,701.572,-352.877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.129,
    y: 571.037,
    width: 23.314,
    height: 2.803,
    style: {
      fill: "rgb(64,63,65)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,701.572,-344.779)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.129,
    y: 566.988,
    width: 23.314,
    height: 2.803,
    style: {
      fill: "rgb(64,63,65)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,701.572,-336.678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.129,
    y: 562.938,
    width: 23.314,
    height: 2.802,
    style: {
      fill: "rgb(64,63,65)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,355.909,191.998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.677L0.134,1.74L-0.535,1.74L0.669,0L0.937,0L0.803,1.071L1.606,1.071L0.268,2.677L0,2.677Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,344.403,191.808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.852C-0.463,2.852 -0.881,2.721 -1.255,2.457C-1.629,2.194 -1.908,1.851 -2.091,1.426C-1.908,1.001 -1.629,0.658 -1.255,0.395C-0.881,0.131 -0.463,0 0,0C0.463,0 0.881,0.131 1.255,0.395C1.629,0.658 1.908,1.001 2.091,1.426C1.908,1.851 1.629,2.194 1.255,2.457C0.881,2.721 0.463,2.852 0,2.852M-0.001,1.958C-0.149,1.958 -0.275,1.907 -0.378,1.803C-0.481,1.699 -0.532,1.573 -0.532,1.425C-0.532,1.277 -0.481,1.151 -0.377,1.048C-0.273,0.945 -0.147,0.894 0.001,0.894C0.149,0.894 0.275,0.946 0.378,1.049C0.481,1.153 0.532,1.279 0.532,1.427C0.532,1.575 0.48,1.701 0.377,1.804C0.273,1.907 0.147,1.958 -0.001,1.958M0.001,2.234C0.225,2.234 0.416,2.155 0.573,1.998C0.73,1.841 0.808,1.65 0.808,1.425C0.808,1.201 0.729,1.01 0.572,0.853C0.415,0.696 0.224,0.618 -0.001,0.618C-0.225,0.618 -0.416,0.697 -0.573,0.854C-0.73,1.011 -0.808,1.202 -0.808,1.427C-0.808,1.651 -0.729,1.842 -0.572,1.999C-0.415,2.156 -0.224,2.234 0.001,2.234",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,301.068,198.985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.938L23.529,0.938C24.133,0.938 24.134,0 23.529,0L0,0C-0.604,0 -0.605,0.938 0,0.938",
    style: {
      fill: "rgb(38,39,38)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,301.068,195.879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.938L12.529,0.938C13.133,0.938 13.134,0 12.529,0L0,0C-0.604,0 -0.605,0.938 0,0.938",
    style: {
      fill: "rgb(38,39,38)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,301.068,204.836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1L19.482,1C20.126,1 20.127,0 19.482,0L0,0C-0.643,0 -0.645,1 0,1",
    style: {
      fill: "rgb(38,39,38)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,301.068,201.895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1L22.776,1C23.42,1 23.421,0 22.776,0L0,0C-0.643,0 -0.645,1 0,1",
    style: {
      fill: "rgb(38,39,38)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,354.241,210.757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-4.456L0,-3.237L0,-4.456L0,0L0,-4.456ZM2.169,-3.237L2.169,-4.456L0,-4.456L0,0L3.408,0L3.408,-3.237L2.169,-3.237ZM0,0.393C-0.105,0.393 -0.197,0.354 -0.275,0.276C-0.354,0.197 -0.393,0.105 -0.393,0L-0.393,-4.456C-0.393,-4.561 -0.354,-4.653 -0.275,-4.731C-0.197,-4.81 -0.105,-4.849 0,-4.849L2.366,-4.849L3.801,-3.414L3.801,0C3.801,0.105 3.762,0.197 3.683,0.276C3.604,0.354 3.513,0.393 3.408,0.393L0,0.393Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,615.926,-358.293)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.608,
    y: 565.876,
    width: 14.71,
    height: 18.541,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,0,792)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.205,
    y: 565.876,
    width: 14.71,
    height: 18.541,
    style: {
      fill: "white"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,574.05,-401.28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.478,
    y: 592.334,
    width: 13.094,
    height: 8.612,
    style: {
      fill: "rgb(38,39,38)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,574.05,-382.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.478,
    y: 582.875,
    width: 13.094,
    height: 8.612,
    style: {
      fill: "rgb(38,39,38)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,574.05,-363.162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.478,
    y: 573.275,
    width: 13.094,
    height: 8.612,
    style: {
      fill: "rgb(38,39,38)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,574.05,-343.68)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.478,
    y: 563.534,
    width: 13.094,
    height: 8.612,
    style: {
      fill: "rgb(38,39,38)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,285.173,196.113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-1.658L0.835,-1.658C0.875,-1.857 0.927,-2.035 0.989,-2.191C1.052,-2.348 1.131,-2.5 1.227,-2.647C0.951,-2.577 0.709,-2.459 0.503,-2.294C0.297,-2.128 0.129,-1.916 0,-1.658M1.172,-1.658L2.244,-1.658C2.203,-1.853 2.135,-2.042 2.039,-2.224C1.944,-2.407 1.831,-2.568 1.702,-2.708C1.584,-2.609 1.485,-2.478 1.404,-2.316C1.323,-2.154 1.245,-1.934 1.172,-1.658M2.575,-1.658L3.404,-1.658C3.283,-1.912 3.116,-2.124 2.904,-2.294C2.692,-2.463 2.448,-2.583 2.172,-2.653C2.264,-2.516 2.342,-2.369 2.407,-2.211C2.471,-2.052 2.528,-1.868 2.575,-1.658M2.631,-0.337L3.515,-0.337C3.541,-0.426 3.558,-0.507 3.567,-0.583C3.577,-0.659 3.581,-0.744 3.581,-0.84C3.581,-0.936 3.577,-1.019 3.567,-1.089C3.558,-1.159 3.541,-1.238 3.515,-1.326L2.636,-1.326C2.647,-1.197 2.655,-1.099 2.658,-1.031C2.662,-0.963 2.664,-0.899 2.664,-0.84C2.664,-0.759 2.661,-0.683 2.656,-0.611C2.65,-0.539 2.642,-0.448 2.631,-0.337M1.111,-0.337L2.299,-0.337C2.314,-0.451 2.323,-0.544 2.327,-0.616C2.33,-0.688 2.332,-0.763 2.332,-0.84C2.332,-0.914 2.33,-0.985 2.327,-1.053C2.323,-1.121 2.314,-1.212 2.299,-1.326L1.111,-1.326C1.096,-1.212 1.087,-1.121 1.083,-1.053C1.08,-0.985 1.078,-0.914 1.078,-0.84C1.078,-0.763 1.08,-0.688 1.083,-0.616C1.087,-0.544 1.096,-0.451 1.111,-0.337M-0.111,-0.337L0.768,-0.337C0.757,-0.437 0.751,-0.526 0.749,-0.605C0.747,-0.684 0.746,-0.763 0.746,-0.84C0.746,-0.932 0.748,-1.014 0.752,-1.086C0.755,-1.158 0.763,-1.238 0.774,-1.326L-0.111,-1.326C-0.136,-1.238 -0.154,-1.159 -0.163,-1.089C-0.172,-1.019 -0.177,-0.936 -0.177,-0.84C-0.177,-0.744 -0.172,-0.659 -0.163,-0.583C-0.154,-0.507 -0.136,-0.426 -0.111,-0.337M2.178,0.989C2.443,0.905 2.681,0.777 2.893,0.608C3.105,0.438 3.276,0.234 3.404,-0.005L2.581,-0.005C2.533,0.194 2.477,0.374 2.412,0.536C2.348,0.698 2.27,0.849 2.178,0.989M1.232,0.995C1.14,0.855 1.061,0.704 0.995,0.542C0.928,0.38 0.873,0.197 0.829,-0.005L0,-0.005C0.14,0.256 0.302,0.462 0.486,0.611C0.671,0.76 0.919,0.888 1.232,0.995M1.702,1.061C1.831,0.929 1.939,0.777 2.026,0.605C2.112,0.434 2.183,0.23 2.238,-0.005L1.172,-0.005C1.223,0.216 1.292,0.415 1.379,0.591C1.466,0.768 1.573,0.925 1.702,1.061M1.702,1.382C1.393,1.382 1.104,1.324 0.835,1.208C0.566,1.092 0.332,0.934 0.133,0.735C-0.066,0.536 -0.223,0.301 -0.337,0.03C-0.451,-0.24 -0.508,-0.53 -0.508,-0.84C-0.508,-1.15 -0.451,-1.438 -0.337,-1.705C-0.223,-1.972 -0.066,-2.205 0.133,-2.404C0.332,-2.603 0.566,-2.759 0.835,-2.871C1.103,-2.984 1.393,-3.04 1.702,-3.04C2.012,-3.04 2.301,-2.984 2.57,-2.871C2.839,-2.759 3.073,-2.603 3.272,-2.404C3.471,-2.205 3.627,-1.972 3.742,-1.705C3.856,-1.438 3.913,-1.15 3.913,-0.84C3.913,-0.531 3.856,-0.24 3.742,0.03C3.627,0.301 3.471,0.536 3.272,0.735C3.073,0.934 2.839,1.092 2.57,1.208C2.301,1.324 2.012,1.382 1.702,1.382",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,286.712,202.519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.179L0.541,4.179L0.627,3.491C0.762,3.458 0.89,3.407 1.011,3.337C1.132,3.267 1.241,3.183 1.34,3.085L1.991,3.368L2.237,2.925L1.659,2.501C1.676,2.432 1.689,2.363 1.699,2.295C1.71,2.228 1.715,2.159 1.715,2.089C1.715,2.02 1.711,1.951 1.702,1.883C1.694,1.816 1.68,1.747 1.659,1.678L2.237,1.254L1.991,0.811L1.34,1.094C1.246,0.987 1.139,0.898 1.02,0.826C0.901,0.755 0.77,0.709 0.627,0.688L0.541,0L0,0L-0.086,0.688C-0.225,0.717 -0.355,0.766 -0.476,0.836C-0.597,0.905 -0.705,0.991 -0.799,1.094L-1.45,0.811L-1.696,1.254L-1.119,1.678C-1.135,1.747 -1.148,1.816 -1.159,1.883C-1.169,1.951 -1.174,2.02 -1.174,2.089C-1.174,2.159 -1.169,2.228 -1.159,2.295C-1.148,2.363 -1.135,2.432 -1.119,2.501L-1.696,2.925L-1.45,3.368L-0.799,3.085C-0.701,3.183 -0.591,3.267 -0.47,3.337C-0.349,3.407 -0.221,3.458 -0.086,3.491L0,4.179ZM0.27,2.52C0.152,2.52 0.05,2.478 -0.034,2.394C-0.118,2.31 -0.16,2.208 -0.16,2.089C-0.16,1.971 -0.118,1.869 -0.034,1.785C0.05,1.701 0.152,1.659 0.27,1.659C0.389,1.659 0.491,1.701 0.575,1.785C0.659,1.869 0.701,1.971 0.701,2.089C0.701,2.208 0.659,2.31 0.575,2.394C0.491,2.478 0.389,2.52 0.27,2.52M0.27,2.888C0.492,2.888 0.68,2.81 0.836,2.655C0.992,2.499 1.069,2.311 1.069,2.089C1.069,1.868 0.992,1.68 0.836,1.524C0.68,1.368 0.492,1.29 0.27,1.29C0.049,1.29 -0.139,1.368 -0.295,1.524C-0.451,1.68 -0.529,1.868 -0.529,2.089C-0.529,2.311 -0.451,2.499 -0.295,2.655C-0.139,2.81 0.049,2.888 0.27,2.888M-0.295,4.548L-0.418,3.773C-0.496,3.745 -0.578,3.706 -0.664,3.657C-0.75,3.607 -0.826,3.556 -0.891,3.503L-1.616,3.835L-2.188,2.827L-1.524,2.341C-1.532,2.304 -1.538,2.262 -1.54,2.215C-1.542,2.168 -1.543,2.126 -1.543,2.089C-1.543,2.052 -1.542,2.01 -1.54,1.963C-1.538,1.916 -1.532,1.874 -1.524,1.837L-2.188,1.352L-1.616,0.344L-0.891,0.676C-0.826,0.623 -0.75,0.571 -0.664,0.522C-0.578,0.473 -0.496,0.436 -0.418,0.412L-0.295,-0.369L0.836,-0.369L0.959,0.405C1.037,0.434 1.12,0.472 1.208,0.519C1.296,0.566 1.371,0.618 1.432,0.676L2.157,0.344L2.729,1.352L2.065,1.825C2.073,1.866 2.078,1.91 2.08,1.957C2.082,2.004 2.083,2.048 2.083,2.089C2.083,2.13 2.082,2.173 2.08,2.218C2.078,2.264 2.073,2.307 2.065,2.348L2.729,2.827L2.157,3.835L1.432,3.503C1.366,3.556 1.292,3.608 1.208,3.66C1.124,3.711 1.041,3.749 0.959,3.773L0.836,4.548L-0.295,4.548Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,286.389,213.989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.529L-0.553,0.945L1.758,-1.366C1.815,-1.423 1.879,-1.453 1.948,-1.455C2.018,-1.457 2.083,-1.427 2.145,-1.366L2.323,-1.187C2.385,-1.126 2.414,-1.059 2.412,-0.988C2.41,-0.916 2.381,-0.851 2.323,-0.794L0,1.529ZM-1.414,2.617C-1.27,2.617 -1.142,2.566 -1.029,2.463C-0.917,2.361 -0.86,2.236 -0.86,2.088C-0.86,2.006 -0.886,1.94 -0.937,1.889C-0.988,1.837 -1.055,1.812 -1.137,1.812C-1.219,1.812 -1.286,1.837 -1.337,1.889C-1.388,1.94 -1.414,2.006 -1.414,2.088C-1.414,2.248 -1.431,2.366 -1.466,2.442C-1.501,2.517 -1.565,2.564 -1.659,2.58C-1.635,2.584 -1.594,2.591 -1.536,2.601C-1.479,2.612 -1.438,2.617 -1.414,2.617M-1.414,2.986C-1.552,2.986 -1.689,2.962 -1.825,2.915C-1.96,2.868 -2.079,2.791 -2.182,2.684C-2.038,2.635 -1.936,2.564 -1.875,2.469C-1.813,2.375 -1.782,2.248 -1.782,2.088C-1.782,1.909 -1.719,1.757 -1.594,1.631C-1.468,1.506 -1.315,1.443 -1.136,1.443C-0.956,1.443 -0.804,1.506 -0.679,1.631C-0.554,1.757 -0.492,1.909 -0.492,2.088C-0.492,2.351 -0.581,2.566 -0.759,2.734C-0.937,2.902 -1.155,2.986 -1.414,2.986",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,284.49,222.282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.687L0,-0.001L0,3.687ZM0.344,3.091L3.35,3.091L2.446,1.886L1.635,2.937L1.063,2.157L0.344,3.091ZM0,3.687L3.688,3.687L3.688,-0.001L0,-0.001L0,3.687ZM0,4.056C-0.098,4.056 -0.184,4.019 -0.258,3.945C-0.332,3.871 -0.369,3.785 -0.369,3.687L-0.369,-0.001C-0.369,-0.099 -0.332,-0.185 -0.258,-0.259C-0.184,-0.332 -0.098,-0.369 0,-0.369L3.688,-0.369C3.786,-0.369 3.872,-0.332 3.946,-0.259C4.019,-0.185 4.056,-0.099 4.056,-0.001L4.056,3.687C4.056,3.785 4.019,3.871 3.946,3.945C3.872,4.019 3.786,4.056 3.688,4.056L0,4.056Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignAppMinimal);
export default __webpack_public_path__ + "static/media/design_app_minimal.9c91907f17b3f2d679b41a312eafd9e5.svg";
export { ForwardRef as ReactComponent };